import React from 'react';
import { BUTTON_SIZE, BUTTON_SIZE_TO_CSS_CLASS_MAP } from '../constants/buttonsConfig.constants';

const PrimaryButton = ({ 
    label, 
    size = BUTTON_SIZE.MEDIUM, 
    disabled = false, 
    onClick, 
    onKeyPress,
    className = '', 
    children 
}) => {
  return (
    <button
      className={`primary-btn ${BUTTON_SIZE_TO_CSS_CLASS_MAP[size]} ${className}`}
      onClick={onClick}
      onKeyUp={onKeyPress}
      disabled={disabled}
    >
      {children || label}
    </button>
  );
};

export default PrimaryButton;
